var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20Warning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8961 6.77211C22.7216 3.07598 17.2589 3.07595 15.0844 6.7721L2.7571 27.7254C0.546322 31.4832 3.40232 36 7.66295 36H32.3175C36.5781 36 39.4341 31.4832 37.2234 27.7254L24.8961 6.77211ZM18.4993 30.5C18.4993 31.3284 19.1708 32 19.9993 32C20.8277 32 21.4993 31.3284 21.4993 30.5V27.5C21.4993 26.6716 20.8277 26 19.9993 26C19.1708 26 18.4993 26.6716 18.4993 27.5V30.5ZM18.4993 20.5C18.4993 21.3284 19.1708 22 19.9993 22C20.8277 22 21.4993 21.3284 21.4993 20.5L21.4993 13.5C21.4993 12.6716 20.8277 12 19.9993 12C19.1708 12 18.4993 12.6716 18.4993 13.5L18.4993 20.5Z",
    fill: "#D46B08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20Warning);
export default __webpack_public_path__ + "static/media/20-warning.f374063bb30d8f36a903bdb454161523.svg";
export { ForwardRef as ReactComponent };